import adminAlertTemplateApi from './adminAlertTemplate.api';

export const uploadApi = {
  mode: 'api',

  async upload(fileOrDataUri) {
    return adminAlertTemplateApi.upload(fileOrDataUri);
  },
};

export default uploadApi;
